import { render } from "./TeamPermissionRow.vue?vue&type=template&id=5b8d930c"
import script from "./TeamPermissionRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamPermissionRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Team/TeamPermissionRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b8d930c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b8d930c', __exports__)) {
    api.reload('5b8d930c', __exports__)
  }
  
  module.hot.accept("./TeamPermissionRow.vue?vue&type=template&id=5b8d930c", () => {
    api.rerender('5b8d930c', render)
  })

}


export default __exports__